// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file groups.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Organization, OrganizationJson } from "./organization_pb";
import { file_organization } from "./organization_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file groups.proto.
 */
export const file_groups: GenFile = /*@__PURE__*/
  fileDesc("Cgxncm91cHMucHJvdG8SCXJhY2Nvb25haSKSAwoLQ3VzdG9tR3JvdXASCgoCaWQYASACKAQSDAoEbmFtZRgCIAIoCRI0ChVvd25lcl9vcmdhbml6YXRpb25faWQYAyACKARSFW93bmVyX29yZ2FuaXphdGlvbl9pZBJHChJvd25lcl9vcmdhbml6YXRpb24YBCABKAsyFy5yYWNjb29uYWkuT3JnYW5pemF0aW9uUhJvd25lcl9vcmdhbml6YXRpb24SNgoWZ3JvdXBfbWVtYmVyc2hpcF9jb3VudBgFIAEoBFIWZ3JvdXBfbWVtYmVyc2hpcF9jb3VudBI6CgpjcmVhdGVkX2F0GGUgAigLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcFIKY3JlYXRlZF9hdBI6Cgp1cGRhdGVkX2F0GGYgAigLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcFIKdXBkYXRlZF9hdBI6CgpkZWxldGVkX2F0GGcgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcFIKZGVsZXRlZF9hdCJXChFDdXN0b21Hcm91cENyZWF0ZRIMCgRuYW1lGAEgAigJEjQKFW93bmVyX29yZ2FuaXphdGlvbl9pZBgCIAIoBFIVb3duZXJfb3JnYW5pemF0aW9uX2lkIi0KEUN1c3RvbUdyb3VwVXBkYXRlEgoKAmlkGAEgAigEEgwKBG5hbWUYAiABKAkikQEKFkN1c3RvbUdyb3VwTGlzdFJlcXVlc3QSNAoVb3duZXJfb3JnYW5pemF0aW9uX2lkGAEgAigEUhVvd25lcl9vcmdhbml6YXRpb25faWQSMAoTaW5jbHVkZV9kZXNjZW5kYW50cxgCIAEoCFITaW5jbHVkZV9kZXNjZW5kYW50cxIPCgdkZWxldGVkGAMgASgIIjkKD0N1c3RvbUdyb3VwTGlzdBImCgZncm91cHMYASADKAsyFi5yYWNjb29uYWkuQ3VzdG9tR3JvdXAiowIKD0dyb3VwTWVtYmVyc2hpcBIKCgJpZBgBIAIoBBIoCg9jdXN0b21fZ3JvdXBfaWQYAiACKARSD2N1c3RvbV9ncm91cF9pZBIYCgd1c2VyX2lkGAMgAigEUgd1c2VyX2lkEgwKBHJvbGUYBCACKAkSOgoMY3VzdG9tX2dyb3VwGAUgASgLMhYucmFjY29vbmFpLkN1c3RvbUdyb3VwUgxjdXN0b21fZ3JvdXASOgoKY3JlYXRlZF9hdBhlIAIoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBSCmNyZWF0ZWRfYXQSOgoKdXBkYXRlZF9hdBhmIAIoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBSCnVwZGF0ZWRfYXQiaQoVR3JvdXBNZW1iZXJzaGlwQ3JlYXRlEigKD2N1c3RvbV9ncm91cF9pZBgBIAIoBFIPY3VzdG9tX2dyb3VwX2lkEhgKB3VzZXJfaWQYAiACKARSB3VzZXJfaWQSDAoEcm9sZRgDIAIoCSIxChVHcm91cE1lbWJlcnNoaXBVcGRhdGUSCgoCaWQYASACKAQSDAoEcm9sZRgCIAEoCSJGChNHcm91cE1lbWJlcnNoaXBMaXN0Ei8KC21lbWJlcnNoaXBzGAEgAygLMhoucmFjY29vbmFpLkdyb3VwTWVtYmVyc2hpcCKiAQoaR3JvdXBNZW1iZXJzaGlwTGlzdFJlcXVlc3QSCgoCaWQYASABKAQSKAoPY3VzdG9tX2dyb3VwX2lkGAIgASgEUg9jdXN0b21fZ3JvdXBfaWQSGAoHdXNlcl9pZBgDIAEoBFIHdXNlcl9pZBI0ChVvd25lcl9vcmdhbml6YXRpb25faWQYBCABKARSFW93bmVyX29yZ2FuaXphdGlvbl9pZCK3AgoTUmVzb3VyY2VBY2Nlc3NHcmFudBIKCgJpZBgBIAIoBBIoCg9jdXN0b21fZ3JvdXBfaWQYAiACKARSD2N1c3RvbV9ncm91cF9pZBIoCg9vcmdhbml6YXRpb25faWQYAyACKARSD29yZ2FuaXphdGlvbl9pZBIkCg1yZXNvdXJjZV90eXBlGAQgAigJUg1yZXNvdXJjZV90eXBlEiIKDGFjY2Vzc19sZXZlbBgFIAIoCVIMYWNjZXNzX2xldmVsEjoKCmNyZWF0ZWRfYXQYZSACKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUgpjcmVhdGVkX2F0EjoKCnVwZGF0ZWRfYXQYZiACKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUgp1cGRhdGVkX2F0IrkBChlSZXNvdXJjZUFjY2Vzc0dyYW50Q3JlYXRlEigKD2N1c3RvbV9ncm91cF9pZBgBIAIoBFIPY3VzdG9tX2dyb3VwX2lkEigKD29yZ2FuaXphdGlvbl9pZBgCIAIoBFIPb3JnYW5pemF0aW9uX2lkEiQKDXJlc291cmNlX3R5cGUYAyACKAlSDXJlc291cmNlX3R5cGUSIgoMYWNjZXNzX2xldmVsGAQgAigJUgxhY2Nlc3NfbGV2ZWwijgEKGFJlc291cmNlQWNjZXNzR3JhbnRJbnB1dBIoCg9vcmdhbml6YXRpb25faWQYASACKARSD29yZ2FuaXphdGlvbl9pZBIkCg1yZXNvdXJjZV90eXBlGAIgAigJUg1yZXNvdXJjZV90eXBlEiIKDGFjY2Vzc19sZXZlbBgDIAIoCVIMYWNjZXNzX2xldmVsIpYBChtDdXN0b21Hcm91cFdpdGhHcmFudHNDcmVhdGUSDAoEbmFtZRgBIAIoCRI0ChVvd25lcl9vcmdhbml6YXRpb25faWQYAiACKARSFW93bmVyX29yZ2FuaXphdGlvbl9pZBIzCgZncmFudHMYAyADKAsyIy5yYWNjb29uYWkuUmVzb3VyY2VBY2Nlc3NHcmFudElucHV0Im4KFUN1c3RvbUdyb3VwV2l0aEdyYW50cxIlCgVncm91cBgBIAIoCzIWLnJhY2Nvb25haS5DdXN0b21Hcm91cBIuCgZncmFudHMYAiADKAsyHi5yYWNjb29uYWkuUmVzb3VyY2VBY2Nlc3NHcmFudCKbAQoZUmVzb3VyY2VBY2Nlc3NHcmFudFVwZGF0ZRIKCgJpZBgBIAIoBBIoCg9vcmdhbml6YXRpb25faWQYAiABKARSD29yZ2FuaXphdGlvbl9pZBIkCg1yZXNvdXJjZV90eXBlGAMgASgJUg1yZXNvdXJjZV90eXBlEiIKDGFjY2Vzc19sZXZlbBgEIAEoCVIMYWNjZXNzX2xldmVsInQKHlJlc291cmNlQWNjZXNzR3JhbnRMaXN0UmVxdWVzdBIoCg9jdXN0b21fZ3JvdXBfaWQYASABKARSD2N1c3RvbV9ncm91cF9pZBIoCg9vcmdhbml6YXRpb25faWQYAiABKARSD29yZ2FuaXphdGlvbl9pZCJJChdSZXNvdXJjZUFjY2Vzc0dyYW50TGlzdBIuCgZncmFudHMYASADKAsyHi5yYWNjb29uYWkuUmVzb3VyY2VBY2Nlc3NHcmFudCJ/CilSZXNvdXJjZUFjY2Vzc0dyYW50QnVsa09yZ2FuaXphdGlvblVwZGF0ZRIoCg9jdXN0b21fZ3JvdXBfaWQYASACKARSD2N1c3RvbV9ncm91cF9pZBIoCg9vcmdhbml6YXRpb25faWQYAiACKARSD29yZ2FuaXphdGlvbl9pZEIGWgQuL3Bi", [file_google_protobuf_timestamp, file_organization]);

/**
 * @generated from message raccoonai.CustomGroup
 */
export type CustomGroup = Message<"raccoonai.CustomGroup"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required string name = 2;
   */
  name: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional raccoonai.Organization owner_organization = 4 [json_name = "owner_organization"];
   */
  ownerOrganization?: Organization;

  /**
   * for a deleted group: the members RestoreCustomGroup brings back
   *
   * @generated from field: optional uint64 group_membership_count = 5 [json_name = "group_membership_count"];
   */
  groupMembershipCount: bigint;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: required google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 103 [json_name = "deleted_at"];
   */
  deletedAt?: Timestamp;
};

/**
 * @generated from message raccoonai.CustomGroup
 */
export type CustomGroupJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required string name = 2;
   */
  name?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional raccoonai.Organization owner_organization = 4 [json_name = "owner_organization"];
   */
  owner_organization?: OrganizationJson;

  /**
   * for a deleted group: the members RestoreCustomGroup brings back
   *
   * @generated from field: optional uint64 group_membership_count = 5 [json_name = "group_membership_count"];
   */
  group_membership_count?: string;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: required google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updated_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 103 [json_name = "deleted_at"];
   */
  deleted_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.CustomGroup.
 * Use `create(CustomGroupSchema)` to create a new message.
 */
export const CustomGroupSchema: GenMessage<CustomGroup, {jsonType: CustomGroupJson}> = /*@__PURE__*/
  messageDesc(file_groups, 0);

/**
 * @generated from message raccoonai.CustomGroupCreate
 */
export type CustomGroupCreate = Message<"raccoonai.CustomGroupCreate"> & {
  /**
   * @generated from field: required string name = 1;
   */
  name: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.CustomGroupCreate
 */
export type CustomGroupCreateJson = {
  /**
   * @generated from field: required string name = 1;
   */
  name?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.CustomGroupCreate.
 * Use `create(CustomGroupCreateSchema)` to create a new message.
 */
export const CustomGroupCreateSchema: GenMessage<CustomGroupCreate, {jsonType: CustomGroupCreateJson}> = /*@__PURE__*/
  messageDesc(file_groups, 1);

/**
 * @generated from message raccoonai.CustomGroupUpdate
 */
export type CustomGroupUpdate = Message<"raccoonai.CustomGroupUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: optional string name = 2;
   */
  name: string;
};

/**
 * @generated from message raccoonai.CustomGroupUpdate
 */
export type CustomGroupUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;
};

/**
 * Describes the message raccoonai.CustomGroupUpdate.
 * Use `create(CustomGroupUpdateSchema)` to create a new message.
 */
export const CustomGroupUpdateSchema: GenMessage<CustomGroupUpdate, {jsonType: CustomGroupUpdateJson}> = /*@__PURE__*/
  messageDesc(file_groups, 2);

/**
 * @generated from message raccoonai.CustomGroupListRequest
 */
export type CustomGroupListRequest = Message<"raccoonai.CustomGroupListRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * also the groups of every descendant organization; owner_organization tells them apart
   *
   * @generated from field: optional bool include_descendants = 2 [json_name = "include_descendants"];
   */
  includeDescendants: boolean;

  /**
   * only the soft-deleted groups, the ones RestoreCustomGroup can bring back
   *
   * @generated from field: optional bool deleted = 3;
   */
  deleted: boolean;
};

/**
 * @generated from message raccoonai.CustomGroupListRequest
 */
export type CustomGroupListRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * also the groups of every descendant organization; owner_organization tells them apart
   *
   * @generated from field: optional bool include_descendants = 2 [json_name = "include_descendants"];
   */
  include_descendants?: boolean;

  /**
   * only the soft-deleted groups, the ones RestoreCustomGroup can bring back
   *
   * @generated from field: optional bool deleted = 3;
   */
  deleted?: boolean;
};

/**
 * Describes the message raccoonai.CustomGroupListRequest.
 * Use `create(CustomGroupListRequestSchema)` to create a new message.
 */
export const CustomGroupListRequestSchema: GenMessage<CustomGroupListRequest, {jsonType: CustomGroupListRequestJson}> = /*@__PURE__*/
  messageDesc(file_groups, 3);

/**
 * @generated from message raccoonai.CustomGroupList
 */
export type CustomGroupList = Message<"raccoonai.CustomGroupList"> & {
  /**
   * @generated from field: repeated raccoonai.CustomGroup groups = 1;
   */
  groups: CustomGroup[];
};

/**
 * @generated from message raccoonai.CustomGroupList
 */
export type CustomGroupListJson = {
  /**
   * @generated from field: repeated raccoonai.CustomGroup groups = 1;
   */
  groups?: CustomGroupJson[];
};

/**
 * Describes the message raccoonai.CustomGroupList.
 * Use `create(CustomGroupListSchema)` to create a new message.
 */
export const CustomGroupListSchema: GenMessage<CustomGroupList, {jsonType: CustomGroupListJson}> = /*@__PURE__*/
  messageDesc(file_groups, 4);

/**
 * @generated from message raccoonai.GroupMembership
 */
export type GroupMembership = Message<"raccoonai.GroupMembership"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 custom_group_id = 2 [json_name = "custom_group_id"];
   */
  customGroupId: bigint;

  /**
   * @generated from field: required uint64 user_id = 3 [json_name = "user_id"];
   */
  userId: bigint;

  /**
   * @generated from field: required string role = 4;
   */
  role: string;

  /**
   * @generated from field: optional raccoonai.CustomGroup custom_group = 5 [json_name = "custom_group"];
   */
  customGroup?: CustomGroup;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: required google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updatedAt?: Timestamp;
};

/**
 * @generated from message raccoonai.GroupMembership
 */
export type GroupMembershipJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 custom_group_id = 2 [json_name = "custom_group_id"];
   */
  custom_group_id?: string;

  /**
   * @generated from field: required uint64 user_id = 3 [json_name = "user_id"];
   */
  user_id?: string;

  /**
   * @generated from field: required string role = 4;
   */
  role?: string;

  /**
   * @generated from field: optional raccoonai.CustomGroup custom_group = 5 [json_name = "custom_group"];
   */
  custom_group?: CustomGroupJson;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: required google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updated_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.GroupMembership.
 * Use `create(GroupMembershipSchema)` to create a new message.
 */
export const GroupMembershipSchema: GenMessage<GroupMembership, {jsonType: GroupMembershipJson}> = /*@__PURE__*/
  messageDesc(file_groups, 5);

/**
 * @generated from message raccoonai.GroupMembershipCreate
 */
export type GroupMembershipCreate = Message<"raccoonai.GroupMembershipCreate"> & {
  /**
   * @generated from field: required uint64 custom_group_id = 1 [json_name = "custom_group_id"];
   */
  customGroupId: bigint;

  /**
   * @generated from field: required uint64 user_id = 2 [json_name = "user_id"];
   */
  userId: bigint;

  /**
   * @generated from field: required string role = 3;
   */
  role: string;
};

/**
 * @generated from message raccoonai.GroupMembershipCreate
 */
export type GroupMembershipCreateJson = {
  /**
   * @generated from field: required uint64 custom_group_id = 1 [json_name = "custom_group_id"];
   */
  custom_group_id?: string;

  /**
   * @generated from field: required uint64 user_id = 2 [json_name = "user_id"];
   */
  user_id?: string;

  /**
   * @generated from field: required string role = 3;
   */
  role?: string;
};

/**
 * Describes the message raccoonai.GroupMembershipCreate.
 * Use `create(GroupMembershipCreateSchema)` to create a new message.
 */
export const GroupMembershipCreateSchema: GenMessage<GroupMembershipCreate, {jsonType: GroupMembershipCreateJson}> = /*@__PURE__*/
  messageDesc(file_groups, 6);

/**
 * @generated from message raccoonai.GroupMembershipUpdate
 */
export type GroupMembershipUpdate = Message<"raccoonai.GroupMembershipUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: optional string role = 2;
   */
  role: string;
};

/**
 * @generated from message raccoonai.GroupMembershipUpdate
 */
export type GroupMembershipUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: optional string role = 2;
   */
  role?: string;
};

/**
 * Describes the message raccoonai.GroupMembershipUpdate.
 * Use `create(GroupMembershipUpdateSchema)` to create a new message.
 */
export const GroupMembershipUpdateSchema: GenMessage<GroupMembershipUpdate, {jsonType: GroupMembershipUpdateJson}> = /*@__PURE__*/
  messageDesc(file_groups, 7);

/**
 * @generated from message raccoonai.GroupMembershipList
 */
export type GroupMembershipList = Message<"raccoonai.GroupMembershipList"> & {
  /**
   * @generated from field: repeated raccoonai.GroupMembership memberships = 1;
   */
  memberships: GroupMembership[];
};

/**
 * @generated from message raccoonai.GroupMembershipList
 */
export type GroupMembershipListJson = {
  /**
   * @generated from field: repeated raccoonai.GroupMembership memberships = 1;
   */
  memberships?: GroupMembershipJson[];
};

/**
 * Describes the message raccoonai.GroupMembershipList.
 * Use `create(GroupMembershipListSchema)` to create a new message.
 */
export const GroupMembershipListSchema: GenMessage<GroupMembershipList, {jsonType: GroupMembershipListJson}> = /*@__PURE__*/
  messageDesc(file_groups, 8);

/**
 * @generated from message raccoonai.GroupMembershipListRequest
 */
export type GroupMembershipListRequest = Message<"raccoonai.GroupMembershipListRequest"> & {
  /**
   * @generated from field: optional uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: optional uint64 custom_group_id = 2 [json_name = "custom_group_id"];
   */
  customGroupId: bigint;

  /**
   * @generated from field: optional uint64 user_id = 3 [json_name = "user_id"];
   */
  userId: bigint;

  /**
   * @generated from field: optional uint64 owner_organization_id = 4 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.GroupMembershipListRequest
 */
export type GroupMembershipListRequestJson = {
  /**
   * @generated from field: optional uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: optional uint64 custom_group_id = 2 [json_name = "custom_group_id"];
   */
  custom_group_id?: string;

  /**
   * @generated from field: optional uint64 user_id = 3 [json_name = "user_id"];
   */
  user_id?: string;

  /**
   * @generated from field: optional uint64 owner_organization_id = 4 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.GroupMembershipListRequest.
 * Use `create(GroupMembershipListRequestSchema)` to create a new message.
 */
export const GroupMembershipListRequestSchema: GenMessage<GroupMembershipListRequest, {jsonType: GroupMembershipListRequestJson}> = /*@__PURE__*/
  messageDesc(file_groups, 9);

/**
 * @generated from message raccoonai.ResourceAccessGrant
 */
export type ResourceAccessGrant = Message<"raccoonai.ResourceAccessGrant"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 custom_group_id = 2 [json_name = "custom_group_id"];
   */
  customGroupId: bigint;

  /**
   * @generated from field: required uint64 organization_id = 3 [json_name = "organization_id"];
   */
  organizationId: bigint;

  /**
   * @generated from field: required string resource_type = 4 [json_name = "resource_type"];
   */
  resourceType: string;

  /**
   * @generated from field: required string access_level = 5 [json_name = "access_level"];
   */
  accessLevel: string;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: required google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updatedAt?: Timestamp;
};

/**
 * @generated from message raccoonai.ResourceAccessGrant
 */
export type ResourceAccessGrantJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 custom_group_id = 2 [json_name = "custom_group_id"];
   */
  custom_group_id?: string;

  /**
   * @generated from field: required uint64 organization_id = 3 [json_name = "organization_id"];
   */
  organization_id?: string;

  /**
   * @generated from field: required string resource_type = 4 [json_name = "resource_type"];
   */
  resource_type?: string;

  /**
   * @generated from field: required string access_level = 5 [json_name = "access_level"];
   */
  access_level?: string;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: required google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updated_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.ResourceAccessGrant.
 * Use `create(ResourceAccessGrantSchema)` to create a new message.
 */
export const ResourceAccessGrantSchema: GenMessage<ResourceAccessGrant, {jsonType: ResourceAccessGrantJson}> = /*@__PURE__*/
  messageDesc(file_groups, 10);

/**
 * @generated from message raccoonai.ResourceAccessGrantCreate
 */
export type ResourceAccessGrantCreate = Message<"raccoonai.ResourceAccessGrantCreate"> & {
  /**
   * @generated from field: required uint64 custom_group_id = 1 [json_name = "custom_group_id"];
   */
  customGroupId: bigint;

  /**
   * @generated from field: required uint64 organization_id = 2 [json_name = "organization_id"];
   */
  organizationId: bigint;

  /**
   * @generated from field: required string resource_type = 3 [json_name = "resource_type"];
   */
  resourceType: string;

  /**
   * @generated from field: required string access_level = 4 [json_name = "access_level"];
   */
  accessLevel: string;
};

/**
 * @generated from message raccoonai.ResourceAccessGrantCreate
 */
export type ResourceAccessGrantCreateJson = {
  /**
   * @generated from field: required uint64 custom_group_id = 1 [json_name = "custom_group_id"];
   */
  custom_group_id?: string;

  /**
   * @generated from field: required uint64 organization_id = 2 [json_name = "organization_id"];
   */
  organization_id?: string;

  /**
   * @generated from field: required string resource_type = 3 [json_name = "resource_type"];
   */
  resource_type?: string;

  /**
   * @generated from field: required string access_level = 4 [json_name = "access_level"];
   */
  access_level?: string;
};

/**
 * Describes the message raccoonai.ResourceAccessGrantCreate.
 * Use `create(ResourceAccessGrantCreateSchema)` to create a new message.
 */
export const ResourceAccessGrantCreateSchema: GenMessage<ResourceAccessGrantCreate, {jsonType: ResourceAccessGrantCreateJson}> = /*@__PURE__*/
  messageDesc(file_groups, 11);

/**
 * ResourceAccessGrantInput is used when creating grants as part of a group creation
 * request — custom_group_id is omitted because it is set from the newly created group.
 *
 * @generated from message raccoonai.ResourceAccessGrantInput
 */
export type ResourceAccessGrantInput = Message<"raccoonai.ResourceAccessGrantInput"> & {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organizationId: bigint;

  /**
   * @generated from field: required string resource_type = 2 [json_name = "resource_type"];
   */
  resourceType: string;

  /**
   * @generated from field: required string access_level = 3 [json_name = "access_level"];
   */
  accessLevel: string;
};

/**
 * ResourceAccessGrantInput is used when creating grants as part of a group creation
 * request — custom_group_id is omitted because it is set from the newly created group.
 *
 * @generated from message raccoonai.ResourceAccessGrantInput
 */
export type ResourceAccessGrantInputJson = {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organization_id?: string;

  /**
   * @generated from field: required string resource_type = 2 [json_name = "resource_type"];
   */
  resource_type?: string;

  /**
   * @generated from field: required string access_level = 3 [json_name = "access_level"];
   */
  access_level?: string;
};

/**
 * Describes the message raccoonai.ResourceAccessGrantInput.
 * Use `create(ResourceAccessGrantInputSchema)` to create a new message.
 */
export const ResourceAccessGrantInputSchema: GenMessage<ResourceAccessGrantInput, {jsonType: ResourceAccessGrantInputJson}> = /*@__PURE__*/
  messageDesc(file_groups, 12);

/**
 * @generated from message raccoonai.CustomGroupWithGrantsCreate
 */
export type CustomGroupWithGrantsCreate = Message<"raccoonai.CustomGroupWithGrantsCreate"> & {
  /**
   * @generated from field: required string name = 1;
   */
  name: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: repeated raccoonai.ResourceAccessGrantInput grants = 3;
   */
  grants: ResourceAccessGrantInput[];
};

/**
 * @generated from message raccoonai.CustomGroupWithGrantsCreate
 */
export type CustomGroupWithGrantsCreateJson = {
  /**
   * @generated from field: required string name = 1;
   */
  name?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: repeated raccoonai.ResourceAccessGrantInput grants = 3;
   */
  grants?: ResourceAccessGrantInputJson[];
};

/**
 * Describes the message raccoonai.CustomGroupWithGrantsCreate.
 * Use `create(CustomGroupWithGrantsCreateSchema)` to create a new message.
 */
export const CustomGroupWithGrantsCreateSchema: GenMessage<CustomGroupWithGrantsCreate, {jsonType: CustomGroupWithGrantsCreateJson}> = /*@__PURE__*/
  messageDesc(file_groups, 13);

/**
 * @generated from message raccoonai.CustomGroupWithGrants
 */
export type CustomGroupWithGrants = Message<"raccoonai.CustomGroupWithGrants"> & {
  /**
   * @generated from field: required raccoonai.CustomGroup group = 1;
   */
  group?: CustomGroup;

  /**
   * @generated from field: repeated raccoonai.ResourceAccessGrant grants = 2;
   */
  grants: ResourceAccessGrant[];
};

/**
 * @generated from message raccoonai.CustomGroupWithGrants
 */
export type CustomGroupWithGrantsJson = {
  /**
   * @generated from field: required raccoonai.CustomGroup group = 1;
   */
  group?: CustomGroupJson;

  /**
   * @generated from field: repeated raccoonai.ResourceAccessGrant grants = 2;
   */
  grants?: ResourceAccessGrantJson[];
};

/**
 * Describes the message raccoonai.CustomGroupWithGrants.
 * Use `create(CustomGroupWithGrantsSchema)` to create a new message.
 */
export const CustomGroupWithGrantsSchema: GenMessage<CustomGroupWithGrants, {jsonType: CustomGroupWithGrantsJson}> = /*@__PURE__*/
  messageDesc(file_groups, 14);

/**
 * @generated from message raccoonai.ResourceAccessGrantUpdate
 */
export type ResourceAccessGrantUpdate = Message<"raccoonai.ResourceAccessGrantUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: optional uint64 organization_id = 2 [json_name = "organization_id"];
   */
  organizationId: bigint;

  /**
   * @generated from field: optional string resource_type = 3 [json_name = "resource_type"];
   */
  resourceType: string;

  /**
   * @generated from field: optional string access_level = 4 [json_name = "access_level"];
   */
  accessLevel: string;
};

/**
 * @generated from message raccoonai.ResourceAccessGrantUpdate
 */
export type ResourceAccessGrantUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: optional uint64 organization_id = 2 [json_name = "organization_id"];
   */
  organization_id?: string;

  /**
   * @generated from field: optional string resource_type = 3 [json_name = "resource_type"];
   */
  resource_type?: string;

  /**
   * @generated from field: optional string access_level = 4 [json_name = "access_level"];
   */
  access_level?: string;
};

/**
 * Describes the message raccoonai.ResourceAccessGrantUpdate.
 * Use `create(ResourceAccessGrantUpdateSchema)` to create a new message.
 */
export const ResourceAccessGrantUpdateSchema: GenMessage<ResourceAccessGrantUpdate, {jsonType: ResourceAccessGrantUpdateJson}> = /*@__PURE__*/
  messageDesc(file_groups, 15);

/**
 * @generated from message raccoonai.ResourceAccessGrantListRequest
 */
export type ResourceAccessGrantListRequest = Message<"raccoonai.ResourceAccessGrantListRequest"> & {
  /**
   * @generated from field: optional uint64 custom_group_id = 1 [json_name = "custom_group_id"];
   */
  customGroupId: bigint;

  /**
   * @generated from field: optional uint64 organization_id = 2 [json_name = "organization_id"];
   */
  organizationId: bigint;
};

/**
 * @generated from message raccoonai.ResourceAccessGrantListRequest
 */
export type ResourceAccessGrantListRequestJson = {
  /**
   * @generated from field: optional uint64 custom_group_id = 1 [json_name = "custom_group_id"];
   */
  custom_group_id?: string;

  /**
   * @generated from field: optional uint64 organization_id = 2 [json_name = "organization_id"];
   */
  organization_id?: string;
};

/**
 * Describes the message raccoonai.ResourceAccessGrantListRequest.
 * Use `create(ResourceAccessGrantListRequestSchema)` to create a new message.
 */
export const ResourceAccessGrantListRequestSchema: GenMessage<ResourceAccessGrantListRequest, {jsonType: ResourceAccessGrantListRequestJson}> = /*@__PURE__*/
  messageDesc(file_groups, 16);

/**
 * @generated from message raccoonai.ResourceAccessGrantList
 */
export type ResourceAccessGrantList = Message<"raccoonai.ResourceAccessGrantList"> & {
  /**
   * @generated from field: repeated raccoonai.ResourceAccessGrant grants = 1;
   */
  grants: ResourceAccessGrant[];
};

/**
 * @generated from message raccoonai.ResourceAccessGrantList
 */
export type ResourceAccessGrantListJson = {
  /**
   * @generated from field: repeated raccoonai.ResourceAccessGrant grants = 1;
   */
  grants?: ResourceAccessGrantJson[];
};

/**
 * Describes the message raccoonai.ResourceAccessGrantList.
 * Use `create(ResourceAccessGrantListSchema)` to create a new message.
 */
export const ResourceAccessGrantListSchema: GenMessage<ResourceAccessGrantList, {jsonType: ResourceAccessGrantListJson}> = /*@__PURE__*/
  messageDesc(file_groups, 17);

/**
 * @generated from message raccoonai.ResourceAccessGrantBulkOrganizationUpdate
 */
export type ResourceAccessGrantBulkOrganizationUpdate = Message<"raccoonai.ResourceAccessGrantBulkOrganizationUpdate"> & {
  /**
   * @generated from field: required uint64 custom_group_id = 1 [json_name = "custom_group_id"];
   */
  customGroupId: bigint;

  /**
   * @generated from field: required uint64 organization_id = 2 [json_name = "organization_id"];
   */
  organizationId: bigint;
};

/**
 * @generated from message raccoonai.ResourceAccessGrantBulkOrganizationUpdate
 */
export type ResourceAccessGrantBulkOrganizationUpdateJson = {
  /**
   * @generated from field: required uint64 custom_group_id = 1 [json_name = "custom_group_id"];
   */
  custom_group_id?: string;

  /**
   * @generated from field: required uint64 organization_id = 2 [json_name = "organization_id"];
   */
  organization_id?: string;
};

/**
 * Describes the message raccoonai.ResourceAccessGrantBulkOrganizationUpdate.
 * Use `create(ResourceAccessGrantBulkOrganizationUpdateSchema)` to create a new message.
 */
export const ResourceAccessGrantBulkOrganizationUpdateSchema: GenMessage<ResourceAccessGrantBulkOrganizationUpdate, {jsonType: ResourceAccessGrantBulkOrganizationUpdateJson}> = /*@__PURE__*/
  messageDesc(file_groups, 18);

